/*
 * @Author: Zhouqi
 * @Date: 2025-10-29 17:19:50
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-30 13:53:27
 */
import { Affix } from 'antd';
import dynamic from 'next/dynamic';
import { forwardRef, memo } from 'react';

import UserAccount from '@/components/UIComponents/UserAccount';

import styles from './index.module.scss';

const FeatureTitle = dynamic(() => import('./featureTitle'), {
  ssr: false,
});
const UserCredit = dynamic(() => import('@/components/UIComponents/UserCredit'), {
  ssr: false,
});

const DisplayHeader = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div ref={ref} className={styles.displayHeader}>
      <Affix offsetTop={0.1}>
        <div className="flex items-center justify-end gap-[18px] h-[56px] px-[20px] bg-[#FFFFFF] border-b-[#E5E5E5] border-b-[1px]">
          <FeatureTitle />
          {/* 余额 */}
          <UserCredit />
          {/* 头像 */}
          <UserAccount />
        </div>
      </Affix>
    </div>
  );
});
export default memo(DisplayHeader);
